"use strict";

var _slicedToArray = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var utils_1 = require("../utils");

var paho_mqtt_1 = require("./paho-mqtt");

var BaseClient =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(BaseClient, _events_1$EventEmitte);

  function BaseClient(options) {
    var _this;

    _classCallCheck(this, BaseClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseClient).call(this));
    _this.subscriptions = new Map(); // TODO figure out how the paho client handles message that are queued and unsent

    _this.publishedMessages = new WeakMap();

    var cid = options.cid,
        onConnected = options.onConnected,
        onConnectionLost = options.onConnectionLost,
        uri = options.uri,
        rest = __rest(options, ["cid", "onConnected", "onConnectionLost", "uri"]);

    _this.protocolClient = new paho_mqtt_1.Client(uri, cid);
    _this.options = rest;

    _this.setupHandlers({
      onConnected: onConnected,
      onConnectionLost: onConnectionLost
    });

    return _this;
  }

  _createClass(BaseClient, [{
    key: "connect",
    value: function connect() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new Promise(function (resolve, reject) {
                  var connectionOptions = Object.assign({
                    onFailure: reject,
                    onSuccess: resolve
                  }, _this2.options);

                  _this2.protocolClient.connect(connectionOptions);
                });

              case 2:
                return _context.abrupt("return");

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3.setupConnectionLostHandler(resolve);

        _this3.protocolClient.disconnect();
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(filter, messageType) {
      var qos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var handler = arguments.length > 3 ? arguments[3] : undefined;
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.subscriptions.set(filter, [utils_1.convertFilterToRegex(filter), messageType, handler]);
                _context2.next = 3;
                return new Promise(function (resolve, reject) {
                  var subscribeOptions = {
                    onFailure: reject,
                    onSuccess: resolve,
                    qos: qos
                  };

                  _this4.protocolClient.subscribe(filter, subscribeOptions);
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "publish",
    value: function publish(message) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return new Promise(function (resolve) {
                  var mqttMessage = message.toMQTT();

                  _this5.protocolClient.send(mqttMessage);

                  _this5.publishedMessages.set(mqttMessage, resolve);
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this6 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return new Promise(function (resolve, reject) {
                  _this6.protocolClient.unsubscribe(filter, {
                    onFailure: reject,
                    onSuccess: resolve
                  });
                });

              case 2:
                this.subscriptions.delete(filter);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "setupHandlers",
    value: function setupHandlers(_ref) {
      var _this7 = this;

      var onConnected = _ref.onConnected,
          onConnectionLost = _ref.onConnectionLost;
      this.setupConnectedHandler(onConnected);
      this.setupConnectionLostHandler(onConnectionLost);
      this.setupMessageArrivedHandler();
      this.setupMessageDeliveredHandler(); // When there is an error because of network disconnection/protocol errors/self emitted errors,
      // we consider to be in an unstable state and immediately auto-disconnect. The upstream code is expected to take
      // appropraite action based on the error

      this.once("error", function (error) {
        if (!onConnected && !onConnectionLost && _this7.protocolClient.isConnected()) {
          _this7.protocolClient.disconnect();
        }

        if (_this7.listenerCount("error") === 0) {
          _this7.emit("error", error);
        }
      });
    }
  }, {
    key: "setupConnectedHandler",
    value: function setupConnectedHandler(onConnected) {
      if (onConnected) {
        this.protocolClient.onConnected = onConnected;
        return;
      }
    }
  }, {
    key: "setupConnectionLostHandler",
    value: function setupConnectionLostHandler(onConnectionLost) {
      var _this8 = this;

      if (onConnectionLost) {
        this.protocolClient.onConnectionLost = onConnectionLost;
        return;
      }

      this.protocolClient.onConnectionLost = function (error) {
        if (typeof onConnectionLost === "function" && error.errorCode === 0) {
          return onConnectionLost(error);
        }

        _this8.emit("error", error);
      };
    }
  }, {
    key: "setupMessageArrivedHandler",
    value: function setupMessageArrivedHandler() {
      var _this9 = this;

      this.protocolClient.onMessageArrived = function (mqttMessage) {
        if (mqttMessage.duplicate) {
          return;
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this9.subscriptions.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref4 = _step.value;

            var _ref3 = _slicedToArray(_ref4, 2);

            var filter = _ref3[0];

            var _ref3$ = _slicedToArray(_ref3[1], 3);

            var regex = _ref3$[0];
            var messageType = _ref3$[1];
            var handler = _ref3$[2];

            if (!regex.test(mqttMessage.destinationName)) {
              continue;
            }

            handler(messageType.fromMQTT(mqttMessage));
            return;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this9.emit("error", new Error("Incoming message not handled: ".concat(mqttMessage)));
      };
    }
  }, {
    key: "setupMessageDeliveredHandler",
    value: function setupMessageDeliveredHandler() {
      var _this10 = this;

      this.protocolClient.onMessageDelivered = function (mqttMessage) {
        var resolve = _this10.publishedMessages.get(mqttMessage);

        if (resolve !== undefined) {
          resolve();
        }
      };
    }
  }]);

  return BaseClient;
}(events_1.EventEmitter);

exports.BaseClient = BaseClient;
exports.default = BaseClient;